import { CloseOutlined } from '@ant-design/icons'
import { Button, Popconfirm } from 'antd'
import { TooltipPlacement } from 'antd/lib/tooltip'
import React from 'react'
import { Link } from 'react-router-dom'

type WithPopupConfirmationParamsProps = {
  title: React.ReactNode
  popupPlacement: TooltipPlacement
  onConfirmAction(): void
}

type WithPopupConfirmationChildrenProps = {
  children: React.ReactNode
}

type WithPopupConfirmationProps = WithPopupConfirmationParamsProps &
  WithPopupConfirmationChildrenProps

export const WithPopupConfirmation: React.FunctionComponent<WithPopupConfirmationProps> = ({
  onConfirmAction,
  title,
  popupPlacement,
  children,
}) => {
  return (
    <Popconfirm
      placement={popupPlacement}
      title={title}
      onConfirm={onConfirmAction}
      okText="Yes"
      okType="danger"
      cancelText="No">
      {children}
    </Popconfirm>
  )
}

export const DeleteButtonWithConfirmation: React.FunctionComponent<
  WithPopupConfirmationParamsProps & { disabled?: boolean }
> = (props) => (
  <WithPopupConfirmation {...props}>
    <Button
      icon={<CloseOutlined />}
      shape="circle"
      size="small"
      danger
      href=""
      disabled={props.disabled}
    />
  </WithPopupConfirmation>
)

export const DeleteLinkWithConfirmation: React.FunctionComponent<WithPopupConfirmationParamsProps> = (
  props,
) => (
  <WithPopupConfirmation {...props}>
    <Link to="#">
      <CloseOutlined />
      <span> Delete</span>
    </Link>
  </WithPopupConfirmation>
)



// WEBPACK FOOTER //
// ./src/components/ActionWithConfirmation.tsx